<div class="wrapper">
  <div class="content">
    <div class="grey-box">
      <img
        class="doubt-man-image"
        src="../../../../assets/images/reload-page-man.png"
      />
      <div class="message-wrapper">
        <span class="title">{{
          "partner.referBrand.brandNotFound.title" | translate
        }}</span>
        <span class="description">{{
          "partner.referBrand.brandNotFound.description" | translate
        }}</span>
        <a class="link" href="mailto:info@socialpals.de">
          {{ "partner.referBrand.brandNotFound.contact" | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
